"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyHint = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const KeyHint = (props) => {
    return React.createElement(rebass_1.Text, Object.assign({ fontSize: 1, color: "inputcolor" }, props));
};
exports.KeyHint = KeyHint;
